define(['app', 'jquery', './ajax-link'], function (app, $, ajaxLink) {
  return ajaxLink.extend({
    ui: {
      container: '.js-load-more-container'
    },

    options: {
      callBack: function (data, dataparam) {
        var pagesTotal = dataparam.itemCount / 10
        var currentPage = dataparam.page

        if (currentPage - 1 <= pagesTotal) {
          $(data).appendTo('.js-load-more-container')
          var nextPage = currentPage + 1
          this.$el.data('params', {
            page: nextPage,
            itemCount: dataparam.itemCount
          })

          if (nextPage >= pagesTotal) {
            this.$el.parent().addClass('is-hidden')
            this.$el.parent().parent().addClass('has-no-more')
          }
        } else {
          this.$el.addClass('is-hidden')
        }

        this.$el.blur()
      }
    },

    events: {
      click: 'ajaxLink'
    }
  })
})
